import { useLoaderData } from 'react-router';

import { useJobPost } from '~/api/jobPosts/useJobPost';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import type { loader } from './EditJobPost.loader';

import { CreateEditJobPostForm } from './CreateEditJobPostForm';

export const EditJobPost = () => {
  const loaderData = useLoaderData<typeof loader>();
  const { data: jobPost } = useJobPost(loaderData.id);

  if (!jobPost || !jobPost.userHasCreated || jobPost.status !== 'Open') {
    return <Redirect to={routes.jobPosts} />;
  }

  return <CreateEditJobPostForm jobPost={jobPost} mode="edit" />;
};
